import { useCallback } from 'react';
import { useLocalStorage } from '../lib/hooks';
import { useSession } from './session';

/**
 * Обрані й останні проєкти. У контракті API ядра немає «обраного» — зберігаємо в браузері
 * окремо для кожного працівника (див. потреби інтеграції у звіті).
 */
export function useFavoriteProjects() {
  const { userId } = useSession();
  const [ids, setIds] = useLocalStorage<string[]>(`ers.fav-projects.${userId}`, []);
  const toggle = useCallback((id: string) => setIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id])), [setIds]);
  return { ids, toggle, has: (id: string) => ids.includes(id) };
}

export function useRecentProjects() {
  const { userId } = useSession();
  const [ids, setIds] = useLocalStorage<string[]>(`ers.recent-projects.${userId}`, []);
  const touch = useCallback((id: string) => setIds((prev) => [id, ...prev.filter((x) => x !== id)].slice(0, 6)), [setIds]);
  return { ids, touch };
}

/** Останній проєкт, у якому створювали задачу (типове значення форми). */
export function useLastProject() {
  const { userId } = useSession();
  return useLocalStorage<string | null>(`ers.last-project.${userId}`, null);
}
